import React, { useId } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { MenuPanel, MenuCheck } from "./MenuPanel";

/** "View" menu: toggles any column whose def does not set `enableHiding: false`. */
const ColumnVisibilityMenu = ({ table }) => {
  const id = useId();
  const columns = table.getAllColumns().filter((column) => column.getCanHide());
  if (columns.length === 0) return null;

  return (
    <Dropdown autoClose="outside" className="dt-menu">
      <Dropdown.Toggle
        as="button"
        type="button"
        className="dt-btn"
        id={"dt-columns" + id}
      >
        <i className="fa fa-columns" aria-hidden="true"></i>
        View
      </Dropdown.Toggle>
      <MenuPanel title="Toggle columns" align="end">
        {columns.map((column, index) => (
          <MenuCheck
            key={column.id}
            index={index}
            checked={column.getIsVisible()}
            onChange={(event) => column.toggleVisibility(event.target.checked)}
            label={
              column.columnDef.meta?.label ||
              (typeof column.columnDef.header === "string"
                ? column.columnDef.header
                : column.id)
            }
          />
        ))}
      </MenuPanel>
    </Dropdown>
  );
};

export default ColumnVisibilityMenu;
